<template>
  <div class="left-tree-box" :class="isBigScreen ? 'left-tree-box-bigscreen' : ''">
    <el-tree
      ref="tree"
      node-key="id"
      :default-expanded-keys="defaultExpandedKeys"
      :data="treeData"
      highlight-current
      :props="defaultProps"
      @node-click="handleNodeClick"
      :expand-on-click-node="false"
      :draggable="isReverseTree"
      :allow-drop="allowDrop"
      :allow-drag="allowDrag"
      @node-drag-start="handleDragStart"
      @node-drop="handleDrop"
      :indent="treeIndent"
    >
      <div
        class="custom-tree-node"
        slot-scope="{ node, data, store }"
        :class="[node.label.value === '地图特效' ? 'hideNode' : '', node.label.value === '行' ? 'hideNode1' : '']"
      >
        <span class="mr4" :class="node.label.iconClassName"></span>
        <span v-if="!node.label.editting" @dblclick="editNodeFunc(node, data)">{{ node.label.value }}</span>
        <el-input
          v-if="node.label.editting && node.isCurrent"
          ref="editInput"
          v-model="edittingValue"
          placeholder="请输入组件的名称"
          @keyup.enter.native="editNodeCloseFunc(node, data)"
          @blur="editNodeCloseFunc(node, data)"
        ></el-input>
      </div>
    </el-tree>
  </div>
</template>

<script>
import {
  getValueByType,
  handleFindLayoutComponentsLevel,
  handleFindLayoutTitlesLevel,
  handleFindAutoLayoutComponentsLevel,
  handleFindLayoutComponentOptionsCols
} from "utils"
import { CATEGORY_MODE } from "@/consts"
export default {
  data() {
    return {
      defaultProps: {
        children: "children",
        label: "label"
      },
      treeData: [],
      defaultExpandedKeys: [], // 默认展开节点
      isReverseTree: false,
      treeIndent: 16, //相邻级节点间的水平缩进，单位为像素
      isBigScreen: false,
      editting: false,
      edittingValue: "",
      treeIdList: []
    }
  },
  props: {
    pageIndex: {
      type: Number,
      default: 0
    },
    isNest: {
      // 该图层是否嵌套在布局图层中
      type: Boolean,
      default: false
    }
  },
  watch: {
    isUpdateLayerDataFlag: function (val) {
      if (val) {
        this.initLayerData()
      }
    },
    "$store.state.states.activeID": {
      deep: true,
      immediate: true,
      handler(n, o) {
        if (n && n.hasOwnProperty("rect_id") && this.treeData.length > 0) {
          this.setDefaultExpandedKeys()
          let findId = null
          if (this.treeIdList.length > 0) {
            findId = this.findTree(n)
          }
          console.log("findId", findId)
          if (findId) {
            this.$refs.tree.setCurrentKey(findId)
            var selected = this.$refs.tree.getCurrentNode()
            if (selected && this.$refs.tree.getNode(selected) && this.$refs.tree.getNode(selected).parent) {
              this.expandParents(this.$refs.tree.getNode(selected).parent)
            }
          }
        }
      }
    }
  },
  created() {},
  computed: {
    isUpdateLayerDataFlag: {
      get() {
        return JSON.parse(JSON.stringify(this.$store.state.states.isUpdateLayerDataFlag))
      }
    }
  },
  mounted() {
    if (this.request_prefix.includes("bigScreen")) {
      this.isReverseTree = true
      this.treeIndent = 12
      this.isBigScreen = true
    }
    this.$on("setDefaultExpandedKeys", this.setDefaultExpandedKeys)
    this.initLayerData()
  },
  beforeDestroy() {
    // setDefaultExpandedKeys方法
    this.$off("setDefaultExpandedKeys", this.setDefaultExpandedKeys)
  },
  methods: {
    //查找数组内符合的值
    findTree(n) {
      let findId = null
      if (n.uid) {
        this.hideLayoutRow()
        //  自由布局内
        if (n.hasOwnProperty("elementInLayoutId")) {
          for (let i = 0; i < this.treeIdList.length; i++) {
            let item = this.treeIdList[i]
            if (n.uid === item.uid && n.elementInLayoutId === item.elementInLayoutId) {
              findId = this.treeIdList[i].idVal
              break
            }
          }
        } else {
          for (let i = 0; i < this.treeIdList.length; i++) {
            let item = this.treeIdList[i]
            if (n.uid === item.uid) {
              findId = this.treeIdList[i].idVal
              break
            }
          }
        }
      } else if (n.hasOwnProperty("swiperContent_id")) {
        //  轮播组件内
        if (n.hasOwnProperty("elementInSwiperId")) {
          for (let i = 0; i < this.treeIdList.length; i++) {
            let item = this.treeIdList[i]
            if (
              n.rect_id === item.rectId &&
              n.elementInSwiperId === item.swiperElementId &&
              n.swiperContent_id === item.swiperContentId
            ) {
              findId = this.treeIdList[i].idVal
              break
            }
          }
        } else {
          for (let i = 0; i < this.treeIdList.length; i++) {
            let item = this.treeIdList[i]
            if (n.rect_id === item.rectId && n.swiperContent_id === item.swiperContentId) {
              findId = this.treeIdList[i].idVal
              break
            }
          }
        }
      } else {
        //  1级普通组件
        for (let i = 0; i < this.treeIdList.length; i++) {
          let item = this.treeIdList[i]
          if (
            !item.hasOwnProperty("uid") &&
            !item.hasOwnProperty("elementInLayoutId") &&
            !item.hasOwnProperty("swiperContent_id") &&
            !item.hasOwnProperty("swiperElementId")
          ) {
            if (n.rect_id === item.rectId && n.container_id === item.containerId) {
              findId = item.idVal
              break
            }
          }
        }
      }
      return findId
    },
    // 初始化图层树
    initLayerData() {
      let _this = this
      let data = [],
        containerId = 0
      this.treeIdList = []
      if (this.isNest) {
        data = [JSON.parse(JSON.stringify(this.$store.state[this.request_prefix].page.children[this.pageIndex]))]
      } else {
        data = [JSON.parse(JSON.stringify(this.$store.state[this.request_prefix].page))]
      }
      formate(data)
      function formate(data, len = 1) {
        // console.log(data)
        if (!Array.isArray(data)) {
          return
        }
        data.forEach((item, index) => {
          if (item.name) {
            item.label = { value: item.name == "大屏模版" ? "大屏" : "页面", type: "page" }
          }
          if (!isNaN(item.container_id)) {
            item.label = { value: "画布", type: "container", id: item.container_id }
          }
          if (item.shape) {
            switch (item.shape) {
              case "cxAutoLayout": // 自动布局数据单独处理
                const autoLayoutResult = handleFindAutoLayoutComponentsLevel(item.options.elementOptions, {
                  label: { value: "自动布局", type: "cxAutoLayout", id: item.rect_id, path: item.path },
                  children: []
                })
                data[index] = autoLayoutResult
                break
              case "swiperComponent": // 轮播组件数据单独处理
                let swiperComponentResult = {
                  label: { value: "轮播", type: "swiperComponent", id: item.rect_id },
                  children: []
                }
                if (item.options && item.options.innerElementInTree) {
                  swiperComponentResult.label.value = item.options.innerElementInTree
                }
                for (let i = 0; i < item.options.content.length; i++) {
                  const contentItem = item.options.content[i]
                  let contentItemResult = {
                    label: {
                      value: "轮播项",
                      type: "swiperComponentItem",
                      id: contentItem.swiperContent_id,
                      swiperComponentId: item.rect_id,
                      swiperContentId: contentItem.swiperContent_id
                    },
                    children: []
                  }
                  for (let j = 0; j < contentItem.elementOptions.length; j++) {
                    const element = contentItem.elementOptions[j]
                    const elementResult = {
                      label: {
                        value: getValueByType(element.innerElement),
                        type: element.innerElement,
                        id: j,
                        swiperComponentId: item.rect_id,
                        swiperContentId: contentItem.swiperContent_id,
                        swiperElementId: element.elementInSwiperId
                      }
                    }
                    contentItemResult.children.push(elementResult)
                  }
                  swiperComponentResult.children.push(contentItemResult)
                }
                data[index] = swiperComponentResult
                break
              case "emptyLayoutComponent": // 自由布局数据单独处理
                const emptyLayoutComponentResult = {
                  label: { value: "自由布局", type: "emptyLayoutComponent", id: item.rect_id },
                  children: []
                }
                if (item.options && item.options.innerElementInTree) {
                  emptyLayoutComponentResult.label.value = item.options.innerElementInTree
                }
                const useActiveIndex = item.options.categoryMode === CATEGORY_MODE.SAME ? 0 : item.options.activeIndex
                const rows = handleFindLayoutComponentsLevel(
                  item.options.rows[useActiveIndex].cols,
                  {
                    label: { value: "行", type: "row", id: useActiveIndex },
                    children: []
                  },
                  _this.isReverseTree
                )
                emptyLayoutComponentResult.children.push(rows)
                data[index] = emptyLayoutComponentResult
                break
              case "layoutComponent": // 自由布局数据单独处理
                const layoutComponentResult = {
                  label: { value: "自由布局", type: "emptyLayoutComponent", id: item.rect_id },
                  children: []
                }
                if (item.options && item.options.innerElementInTree) {
                  layoutComponentResult.label.value = item.options.innerElementInTree
                }
                const _useActiveIndex = item.options.categoryMode === CATEGORY_MODE.SAME ? 0 : item.options.activeIndex
                const layoutComponentResultRows = handleFindLayoutComponentsLevel(
                  item.options.rows[_useActiveIndex].cols,
                  {
                    label: { value: "行", type: "row", id: _useActiveIndex },
                    children: []
                  },
                  _this.isReverseTree
                )
                //暂时不放出自由布局中的其他部分
                // const layoutComponentTitleOptions = handleFindLayoutTitlesLevel(item.options.titleOptions, {
                //   label: { value: "其他", type: "titleOptions" },
                //   children: []
                // })
                layoutComponentResult.children.push(layoutComponentResultRows)
                // layoutComponentResult.children.push(layoutComponentTitleOptions)
                data[index] = layoutComponentResult
                break
              case "layoutComponentBigScreen": // 自由布局数据单独处理
                const layoutComponentBigScreenResult = {
                  label: { value: "自由布局", type: "emptyLayoutComponent", id: item.rect_id },
                  children: []
                }
                if (item.options && item.options.innerElementInTree) {
                  layoutComponentBigScreenResult.label.value = item.options.innerElementInTree
                }
                //为了解决 大屏 图层里只显示自由布局第一个标签和里面的内容
                let rowLenth = item.options.rows.length
                for (let i = 0; i < rowLenth; i++) {
                  const layoutComponentBigScreenResultRows = handleFindLayoutComponentsLevel(
                    item.options.rows[i].cols,
                    {
                      label: { value: "行", type: "row", id: i },
                      children: []
                    },
                    _this.isReverseTree
                  )
                  layoutComponentBigScreenResult.children.push(layoutComponentBigScreenResultRows)
                }
                data[index] = layoutComponentBigScreenResult
                break
              default:
                item.label = { value: getValueByType(item.shape), type: item.shape, id: item.rect_id }
                if (item.options && item.options.innerElementInTree) {
                  item.label.value = item.options.innerElementInTree
                }
                if (item.options && item.options.hideInLayerTree) {
                  item.label.value = "地图特效"
                }
            }
          }

          for (const k in item) {
            const element = item[k]
            if (k !== "label" && k !== "children") {
              delete item[k]
            }
            if (Array.isArray(element) && k.type !== "row") {
              formate(item.children, len + 1)
            }
          }
          if (item && item.label && item.label.type) {
            let { iconClass, canEdit } = _this.getComponentClassName(item.label.type)
            item.label.iconClassName = iconClass
            item.label.canEdit = canEdit
            item.label.editting = false
          }
        })
      }
      function setId(list, start = 1) {
        return list.reduce((id, item) => {
          item.id = id++
          if (item.label && item.label.type !== "page" && item.label.type !== "container") {
            let uidStr = "",
              elementIdStr = "",
              isRow = false
            //自由布局列
            if (item.label.uid) {
              uidStr = {
                uid: item.label.uid
              }
            }
            //自由布局内部组件
            if (item.label.elementInLayoutId || item.label.elementInLayoutId === 0) {
              elementIdStr = {
                elementInLayoutId: item.label.elementInLayoutId
              }
            }
            //自由布局行
            if (item.label.type && item.label.type === "row") {
              isRow = true
            }
            //自由布局 列 改名为 单元格
            if (item.label.type && item.label.type === "col") {
              item.label.value = "单元格"
            }
            /* 轮播组件 */
            let swiperContentStr = "",
              swiperElementStr = ""
            //轮播项
            if (item.label.hasOwnProperty("swiperContentId")) {
              swiperContentStr = {
                rectId: item.label.swiperComponentId,
                swiperContentId: item.label.swiperContentId
              }
            }
            if (item.label.hasOwnProperty("swiperElementId")) {
              swiperElementStr = {
                rectId: item.label.swiperComponentId,
                swiperElementId: item.label.swiperElementId
              }
            }

            let obj1 = {
              idVal: item.id,
              rectId: item.label.id,
              containerId: containerId,
              ...uidStr,
              ...elementIdStr,
              ...swiperContentStr,
              ...swiperElementStr
            }
            if (!isRow) {
              //排除自由布局的行
              _this.treeIdList.push(obj1)
            }
          }
          if (item.label && item.label.type === "container") {
            containerId = item.label.id
          }
          return Array.isArray(item.children) ? setId(item.children, id) : id
        }, start)
      }

      setId(data)
      // this.treeData = data
      this.treeData = this.isReverseTree ? this.reverseTreeData(data) : data
      // 每次发生节点变化的时候，都需要记录当前展开节点层级
      this.$emit("setDefaultExpandedKeys")
      this.$store.commit("states/changeIsUpdateLayerDataFlag", false)

      //隐藏地图组件特效的文本组件
      this.$nextTick(() => {
        let domList = document.querySelectorAll(".hideNode")
        domList.forEach(item => {
          item.parentNode.parentNode.style.display = "none"
        })
        this.hideLayoutRow()
      })
    },
    hideLayoutRow(){
      // 隐藏自由布局的行
      this.$nextTick(() => {
        let domList1 = document.querySelectorAll(".hideNode1")
        domList1.forEach(item => {
          item.parentNode.style.display = "none"
        })
      })
    },
    // 倒序处理树
    reverseTreeData(data) {
      // 节点倒序排序，自由布局需要单独处理
      let data2 = data[0].children[0].children.reverse()
      data[0].children[0].children = data2
      return data
    },
    // 渲染树
    getComponentClassName(name) {
      // 根据当前节点type返回对应图标
      let iconClass = "",
        canEdit = false
      switch (name) {
        case "page":
          iconClass = "icon-portal-page-layer"
          break
        case "cxAutoLayout":
          iconClass = "icon-portal-row"
          break
        case "container":
          iconClass = "icon-portal-artboard1"
          break
        case "emptyLayoutComponent":
          iconClass = "icon-portal-card-view1"
          canEdit = true
          break
        case "row":
          iconClass = "icon-portal-row"
          break
        case "col":
          iconClass = "icon-portal-col"
          break
        case "cxButton":
          iconClass = "icon-portal-button"
          canEdit = true
          break
        case "cxLabel":
          iconClass = "icon-portal-icon_tag"
          break
        case "imageComponent":
          iconClass = "icon-portal-pic1"
          canEdit = true
          break
        case "cxText":
          iconClass = "icon-portal-text1"
          canEdit = true
          break
        case "cxBorder":
          iconClass = "icon-portal-boder"
          break
        case "cxVideo":
          iconClass = "icon-portal-video"
          canEdit = true
          break
        case "swiperComponent":
          iconClass = "icon-portal-carousel"
          canEdit = true
          break
        case "swiperComponentItem":
          iconClass = "icon-portal-container"
          break
        case "cxTable":
          iconClass = "icon-portal-table"
          canEdit = true
          break
        case "cxRealMap":
          iconClass = "icon-portal-map"
          canEdit = true
          break
        case "cxMap3D":
          iconClass = "icon-portal-map"
          canEdit = true
          break
        case "cxPie":
          iconClass = "icon-portal-chart-pie"
          canEdit = true
          break
        case "cxPie3D":
          iconClass = "icon-portal-chart-pie"
          canEdit = true
          break
        case "cxBar":
          iconClass = "icon-portal-chart-histogram"
          canEdit = true
          break
        case "cxLine":
          iconClass = "icon-portal-chart-line"
          canEdit = true
          break
        case "cxRadar":
          iconClass = "icon-portal-chart-radar"
          canEdit = true
          break
        case "cxCloud":
          iconClass = "icon-portal-chart-textCloud"
          canEdit = true
          break
        case "cxMap":
          iconClass = "icon-portal-chart-earth"
          canEdit = true
          break
        case "cxGauge":
          iconClass = "icon-portal-chart-dashboard"
          canEdit = true
          break
        case "cxLiquidFill":
          iconClass = "icon-portal-chart-water-level"
          canEdit = true
          break
        case "cxSelect":
          iconClass = "icon-portal-selector"
          canEdit = true
          break
        case "cxShape":
          iconClass = "icon-portal-shape"
          break
        case "cxDigitRoll":
          iconClass = "icon-portal-number-flop"
          canEdit = true
          break
        case "cxDate":
          iconClass = "icon-portal-date"
          canEdit = true
          break
        case "cxIframe":
          iconClass = "icon-portal-iframe"
          canEdit = true
          break
        case "cxLogicText":
          iconClass = "icon-portal-logical_text"
          break
        case "cxReturn":
          iconClass = "icon-portal-return"
          break
        case "cxWeather":
          iconClass = "icon-portal-weather"
          break
        case "cxAnimate":
          iconClass = "icon-portal-animate"
          break
        case "cxInput":
          iconClass = "icon-portal-input"
          break
        case "cxTabs":
          iconClass = "icon-portal-tab"
          break
        case "cxRadio":
          iconClass = "icon-portal-adjustment"
          break
        case "cxIcon":
          iconClass = "icon-portal-menu_icon1"
          canEdit = true
          break
        case "cxNavMenuVertical":
          iconClass = "icon-portal-menu_navMenuVertical"
          canEdit = true
          break
        case "cxPictorialBar":
          iconClass = "icon-portal-pictorial-bar"
          canEdit = true
          break
        case "cxDatePicker":
          iconClass = "icon-portal-time-selector"
          canEdit = true
          break
      }
      return { iconClass, canEdit }
    },
    // 找到当前节点的path
    handelFindPath(data, temp, cb) {
      if (data.parent) {
        temp.push({ label: data.data.label })
        this.handelFindPath(data.parent, temp, cb)
      } else {
        cb(temp)
      }
    },
    handleNodeClick(data, node, el) {
      this.currentNodeResult = {}
      let result = {}
      let temp = []
      this.handelFindPath(this.$refs.tree.currentNode.node, temp, item => {
        result.list = item
      })
      if (!this.isNest) {
        // 当画布图层不是嵌套在布局图层中时，特殊处理下组件路径
        result.list.reverse().shift() // 删除路径第一层page
      } else {
        result.list.reverse()
      }
      if (result.list.length === 0) return
      result.currentNode = result.list[result.list.length - 1].label
      // 组装当前节点的ids
      let activeID = {
        pageId: null,
        container_id: null,
        rect_id: null,
        directionIndex: null,
        elementInLayoutId: null,
        elementInSwiperId: null,
        swiperContent_id: null,
        uid: null,
        elementInAutoLayoutId: null,
        path: []
      }

      switch (
        result.currentNode.type // 当前节点的类型
      ) {
        case "container":
          activeID.container_id = result.currentNode.id
          this.$store.commit("states/changeActiveID", activeID)
          this.$store.dispatch(this.request_prefix + "/setContainerActive", activeID)
          this.$store.commit(
            "states/changeElementType",
            this.request_prefix.includes("bigScreen") ? "bigScreenContainer" : "container"
          )
          break
        case "cxAutoLayout": // 自由布局可以嵌套自动布局，所以要判断当前自由布局的路径有3种情况：1、是直接在画布中； 2、自动布局嵌套在自动布局中；3、自动布局嵌套在自由布局中
          if (result.list.length > 2) {
            activeID.container_id = result.list[0].label.id
            activeID.rect_id = result.list[1].label.id
            activeID.elementInAutoLayoutId = result.currentNode.id
            activeID.path = result.currentNode.path
            // 自动布局可以嵌套自动布局，所以需要找出path
            // 自动布局可以嵌套在自由布局中，所以需要找出放自动布局组件的这一层col的uid,以及
            let paths = []
            let layoutParams = []
            for (let i = 0; i < result.list.length; i++) {
              if (result.list[i].label.type === "col") {
                const temp = {
                  uid: result.list[i].label.uid,
                  id: result.list[i].label.id
                }
                layoutParams.push(temp)
              }
            }
            // 只需要最近一层col的uid
            activeID.uid = layoutParams.length > 0 ? layoutParams[layoutParams.length - 1].uid : null
            activeID.elementInLayoutId = layoutParams.length > 0 ? layoutParams[layoutParams.length - 1].id : null

            this.$store.commit("states/changeActiveID", activeID)
            const setAutoLayoutNewActive = {
              container_id: activeID.container_id,
              rect_id: activeID.rect_id,
              uid: activeID.uid,
              elementInAutoLayoutId: activeID.elementInAutoLayoutId,
              elementInLayoutId: activeID.elementInLayoutId,
              option_name: "active",
              option_val: true,
              path: activeID.path,
              elementName: result.currentNode.type
            }
            this.$store.dispatch(this.request_prefix + "/setActive", JSON.parse(JSON.stringify(activeID)))
            this.$store.dispatch(this.request_prefix + "/changeElementInAutoLayoutActive", setAutoLayoutNewActive)
            this.$store.commit("states/changeElementType", result.currentNode.type)
          } else {
            activeID.container_id = result.list[0].label.id
            activeID.rect_id = result.list[1].label.id
            this.$store.dispatch(this.request_prefix + "/setActive", activeID)
            this.$store.commit("states/changeActiveID", activeID)
            this.$store.commit("states/changeElementType", result.currentNode.type)
          }
          break
        case "row":
          break
        case "col":
          activeID.container_id = result.list[0].label.id
          activeID.rect_id = result.list[1].label.id
          // activeID.elementInLayoutId = result.currentNode.id
          activeID.uid = result.currentNode.uid
          // col暂时只支持componentBox这层的点击
          // if (!document.getElementById("componentBox_after" + activeID.uid)) return
          if (!this.$store.state.states.alignHelperStatus && !localStorage.getItem("multipleComponent")) {
            let param = {
              container_id: activeID.container_id,
              rect_id: activeID.rect_id,
              uid: activeID.uid,
              option_name: "isActive",
              option_val: "delAllActive"
            }
            let delAllTitleActive = {
              container_id: activeID.container_id,
              rect_id: activeID.rect_id
            }
            this.$store.dispatch(this.request_prefix + "/delAllLayoutTitleActive", delAllTitleActive)
            this.$store.dispatch(this.request_prefix + "/changeLayoutActive", param)
            this.$store.commit("states/changeElementType", "colsComponent")
            this.$store.commit("states/changeActiveID", activeID)
            this.$store.dispatch(this.request_prefix + "/setActive", activeID)
            if (document.getElementById("componentBox_after" + activeID.uid)){
              document.getElementById("componentBox_after" + activeID.uid).classList.add("activeCol")
            }
          }
          break
        case "swiperComponentItem":
          break
        // case "direction":
        //   activeID.container_id = result.list[0].label.id
        //   activeID.rect_id = result.list[1].label.id
        //   activeID.elementInLayoutId = result.currentNode.id
        //   activeID.directionIndex = result.list[result.list.length - 2].label.id
        //   break
        default:
          // 考虑当前节点是基础组件节点，找到当前节点是在画布中，还是在自由布局col中，还是在自动布局中，还是在轮播中，还是在自由布局组件的title中
          switch (result.list[result.list.length - 2].label.type) {
            case "container": // 在画布中
              activeID.container_id = result.list[0].label.id
              activeID.rect_id = result.currentNode.id
              this.$store.dispatch(this.request_prefix + "/setActive", activeID)
              this.$store.commit("states/changeActiveID", activeID)
              this.$store.commit("states/changeElementType", result.currentNode.type)
              break
            case "swiperComponentItem": //在轮播中
              activeID.container_id = result.list[0].label.id
              activeID.rect_id = result.list[1].label.id
              activeID.elementInSwiperId = result.currentNode.id
              activeID.swiperContent_id = result.list[result.list.length - 2].label.id
              this.$store.commit("states/changeActiveID", activeID)
              if (!this.$getOptions(activeID).isActive)
                this.$store.dispatch(this.request_prefix + "/setActive", activeID)
              this.$store.dispatch(this.request_prefix + "/changeElementInSwiperActive", activeID)
              this.$store.commit("states/changeElementType", result.currentNode.type)
              break
            case "col": //在自由布局中
              activeID.container_id = result.list[0].label.id
              activeID.rect_id = result.list[1].label.id
              activeID.elementInLayoutId = result.currentNode.elementInLayoutId
              activeID.uid = result.list[result.list.length - 2].label.uid

              setTimeout(this.$store.commit("states/changeActiveID", activeID), 100)
              //是否对其辅助 都需要设置当前选中元素的active效果
              const setNewActive = {
                container_id: activeID.container_id,
                rect_id: activeID.rect_id,
                uid: activeID.uid,
                elementInLayoutId: activeID.elementInLayoutId,
                option_name: "isActive",
                option_val: true
              }
              if (!this.$store.state.states.alignHelperStatus && !localStorage.getItem("multipleComponent")) {
                const delActive = {
                  container_id: activeID.container_id,
                  rect_id: activeID.rect_id,
                  uid: activeID.uid,
                  elementInLayoutId: activeID.elementInLayoutId,
                  option_name: "isActive",
                  option_val: "delAllActive"
                }
                let delAllTitleActive = {
                  container_id: activeID.container_id,
                  rect_id: activeID.rect_id
                }
                //初次进来 先取消当前cols中的所有元素的active效果
                this.$store.dispatch(this.request_prefix + "/delAllLayoutTitleActive", delAllTitleActive)
                this.$store.dispatch(this.request_prefix + "/changeLayoutActive", delActive)
                this.$store.dispatch(this.request_prefix + "/setActive", JSON.parse(JSON.stringify(activeID)))
                this.$store.dispatch(this.request_prefix + "/changeLayoutActive", setNewActive)
                this.$store.commit("states/changeElementType", result.currentNode.type)
              } else {
                this.$store.dispatch(this.request_prefix + "/changeLayoutActive", setNewActive)
                this.$store.commit(this.request_prefix + "/ENABLE_ACTIVE", {
                  container_id: this.ids.container_id,
                  rect_id: this.ids.rect_id
                })
                let newArr = JSON.parse(sessionStorage.getItem("tmpComponents")) || []
                if (localStorage.getItem("multipleComponent")) {
                  newArr.push({
                    container_id: activeID.container_id,
                    rect_id: activeID.rect_id,
                    uid: activeID.uid,
                    elementInLayoutId: activeID.elementInLayoutId,
                    option_name: "isActive",
                    option_val: true
                  })
                }else{
                  newArr=[{
                    container_id: activeID.container_id,
                    rect_id: activeID.rect_id,
                    uid: activeID.uid,
                    elementInLayoutId: activeID.elementInLayoutId,
                    option_name: "isActive",
                    option_val: true
                  }]
                }
                sessionStorage.setItem("tmpComponents", JSON.stringify(newArr))
              }
              break
            case "cxAutoLayout": // 在自动布局中
              activeID.container_id = result.list[0].label.id
              activeID.rect_id = result.list[1].label.id
              activeID.elementInAutoLayoutId = result.currentNode.id
              activeID.path = []
              for (let i = 2; i < result.list.length; i++) {
                if (result.list[i].label.type === "cxAutoLayout") {
                  activeID.path.push(result.list[i].label.id)
                }
              }
              // 自动布局可以嵌套自动布局，所以需要找出path
              // 自动布局可以嵌套在自由布局中，所以需要找出放自动布局组件的这一层col的uid,以及
              let paths = []
              let layoutParams = []
              for (let i = 0; i < result.list.length; i++) {
                if (result.list[i].label.type === "cxAutoLayout") {
                  paths.push(result.list[i].label.id)
                }
                if (result.list[i].label.type === "col") {
                  const temp = {
                    uid: result.list[i].label.uid,
                    id: result.list[i].label.id
                  }
                  layoutParams.push(temp)
                }
              }
              // 第一层的path不需要
              paths.shift()
              activeID.path = paths
              // 只需要最近一层col的uid
              activeID.uid = layoutParams.length > 0 ? layoutParams[layoutParams.length - 1].uid : null
              activeID.elementInLayoutId = layoutParams.length > 0 ? layoutParams[layoutParams.length - 1].id : null

              this.$store.commit("states/changeActiveID", activeID)
              const setAutoLayoutNewActive = {
                container_id: activeID.container_id,
                rect_id: activeID.rect_id,
                uid: activeID.uid,
                elementInAutoLayoutId: activeID.elementInAutoLayoutId,
                elementInLayoutId: activeID.elementInLayoutId,
                option_name: "active",
                option_val: true,
                path: activeID.path,
                elementName: result.currentNode.type
              }
              console.log("params", activeID)
              console.log("params1", setAutoLayoutNewActive)
              this.$store.dispatch(this.request_prefix + "/setActive", JSON.parse(JSON.stringify(activeID)))
              this.$store.dispatch(this.request_prefix + "/changeElementInAutoLayoutActive", setAutoLayoutNewActive)
              this.$store.commit("states/changeElementType", result.currentNode.type)
              break
          }
      }
    },
    // 设置图层树默认展开层级
    setDefaultExpandedKeys() {
      // 获取树形组件实例
      let allNodes = this.$refs.tree.store._getAllNodes()
      // 添加默认展开第一二级
      let defaultExpandedNodes = []
      if (this.request_prefix.includes("bigScreen")) {
        defaultExpandedNodes = [0, 1, 2]
      }
      // console.log(allNodes)
      if (!Array.isArray(allNodes)) {
        return
      }
      allNodes.forEach(node => {
        node.expanded && defaultExpandedNodes.push(node.data.id)
      })
      this.defaultExpandedKeys = defaultExpandedNodes
    },
    //  拖拽时判定目标节点能否被放置,type 参数有三种情况：'prev'、'inner' 和 'next'，分别表示放置在目标节点前、插入至目标节点和放置在目标节点后
    allowDrop(draggingNode, dropNode, type) {
      // 只允许 同级同父元素拖拽
      if (draggingNode.level === dropNode.level && draggingNode.parent.id === dropNode.parent.id) {
        return type === "prev" || type === "next"
      } else {
        return false
      }
    },
    //判断节点能否被拖拽
    allowDrag(draggingNode) {
      let isAllowDrag = true
      if (
        draggingNode.data.label.type === "row" ||
        draggingNode.data.label.type === "col" ||
        draggingNode.data.label.type === "swiperComponentItem" ||
        draggingNode.parent?.data.label.type === "swiperComponentItem"
      ) {
        isAllowDrag = false
      }
      return isAllowDrag
    },
    handleDragStart(node, ev) {
      // this.editNodeCloseFunc(node, node.data)
    },
    //拖拽成功完成时触发的事件,共四个参数，
    // 依次为：被拖拽节点对应的 Node、结束拖拽时最后进入的节点、被拖拽节点的放置位置（before、after、inner）、event
    handleDrop(draggingNode, dropNode, dropType, ev) {
      let childrenTree = this.$store.state[this.request_prefix].page.children[0].children
      if (draggingNode.level === 3) {
        // 第一层组件间拖拽
        childrenTree = this.moveLevelFunc(childrenTree, draggingNode, dropNode, dropType)
      } else {
        //  自由布局内的组件拖拽
        childrenTree = this.moveLevelFunc(childrenTree, draggingNode, dropNode, dropType, true)
      }
    },
    // 拖拽后改变数组顺序
    moveLevelFunc(childrens, draggingNode, dropNode, dropType, inLayoutComponent) {
      let draggingNodeIndex = 0
      let dropNodeIndex = 0
      if (!inLayoutComponent) {
        //  非自由布局内部   的组件拖拽
        // 获取拖拽元素以及目标组件的下标
        childrens.forEach((item, index) => {
          if (item.rect_id === draggingNode.data.label.id) {
            draggingNodeIndex = index
          }
          if (item.rect_id === dropNode.data.label.id) {
            dropNodeIndex = index
          }
        })
        //  数组顺序修改
        const itemNode = childrens[draggingNodeIndex]
        childrens.splice(draggingNodeIndex, 1)
        if (dropType === "before") {
          childrens.splice(dropNodeIndex, 0, itemNode)
        } else if (dropType === "after") {
          if (dropNodeIndex < 1) {
            childrens.unshift(itemNode)
          } else {
            childrens.splice(dropNodeIndex - 1, 0, itemNode)
          }
        }
        return childrens
      } else {
        //  自由布局内部   的组件拖拽
        let find1 = {}
        //查找最上层的父元素
        function findParentTop(node, levelNumber, find) {
          let result = node
          if (result.level === levelNumber) {
            if (levelNumber === 2) {
              find.container_id = result.data.label.id
            } else if (levelNumber === 3) {
              find.rect_id = result.data.label.id
            }
            return
          } else if (result.parent && result.parent.level >= levelNumber) {
            findParentTop(result.parent, levelNumber, find)
          }
        }
        findParentTop(dropNode, 3, find1)
        findParentTop(dropNode, 2, find1)
        // 查找当前组件的列父元素
        const rectAttr = this.getRectAttribute.call(this, find1)
        const useActiveIndex = rectAttr.options.categoryMode === CATEGORY_MODE.SAME ? 0 : rectAttr.options.activeIndex
        const pOptions = [rectAttr.options.rows[useActiveIndex]]
        let colUid = dropNode.parent.data.label.uid
        const colOptions = handleFindLayoutComponentOptionsCols(pOptions, colUid)
        let colList = colOptions.elementOptions
        // 获取拖拽元素以及目标组件的下标
        let draggingNodeIndex = draggingNode.data.label.id
        let dropNodeIndex = dropNode.data.label.id
        //  数组顺序修改
        const itemNode = colList[draggingNodeIndex]
        colList.splice(draggingNodeIndex, 1)
        if (dropType === "before") {
          colList.splice(dropNodeIndex + 1, 0, itemNode)
        } else if (dropType === "after") {
          colList.splice(dropNodeIndex - 1, 0, itemNode)
        }
      }
    },
    //  组件名称修改
    editNodeFunc(node, data) {
      // 仅限 大屏 &&  第一层组件可以修改名称
      if (this.isBigScreen && node.level === 3) {
        data.label.editting = true
        this.edittingValue = data.label.value
        setTimeout(() => {
          this.$refs.editInput.focus()
        }, 0)
      }
    },
    // 修改完成
    editNodeCloseFunc(node, data) {
      //获取画布id
      let containerId = node.parent.data.label.id
      this.$changeOptionsEV(this.edittingValue, "innerElementInTree", false, null, {
        container_id: containerId,
        rect_id: data.label.id
      })
      data.label.value = this.edittingValue
      data.label.editting = false
    },
    //  展开树结构
    expandParents(node) {
      node.expanded = true
      if (node.parent) {
        this.expandParents(node.parent)
      }
    }
  }
}
</script>

<style scoped>
::v-deep .el-tree-node__content:hover {
  background-color: var(--elTreeHoverColor) !important;
  color: var(--elCollapseItemContentColor);
}
::v-deep .is-current > .el-tree-node__content {
  background-color: var(--elTreeActiveColor) !important;
  color: #fff;
  /* background: var(--elCollapseItemWrapBgColor) !important */
}
::v-deep .el-tree-node__content {
  height: 32px !important;
  background: var(--elCollapseItemWrapBgColor) !important;
}
::v-deep .el-tree {
  background: var(--elCollapseItemWrapBgColor) !important;
  color: var(--elCollapseItemContentColor);
}

::v-deep .left-tree-box-bigscreen .el-tree-node__content {
  overflow: auto;
}
::v-deep .custom-tree-node .el-input .el-input__inner {
  height: 26px;
  width: 74%;
}
</style>
